import React from 'react'
import SubText from '@components/text/subText'

import { Container } from './styles'
import colors from '@settings/styleSettings'

const RequiredFields = () => (
  <Container>
    <SubText style={{ color: colors.strongRed }}>* </SubText>
    <SubText>Campos Obrigatórios</SubText>
  </Container>
)

export default RequiredFields
